const zero = () => 0;

export default zero;
